import React from "react";
import FeedCard from "./FeedCard";
import ProductSuggestionRow from "./ProductSuggestionRow";
import ProfessionSuggestionRow from "./ProfessionSuggestionRow";
import WorkSuggestionRow from "./WorkSuggestionRow";

function FeedList({
  feed,
  menuPost,
  setMenuPost,
  menuRef,
  setActivePost,
  setShowComments,
  onLike,
  onSave,
  onHide,
  onReport,
  savedPosts,
  onConsult,
}) {
  return (
    <main className="home-feed">
      {feed?.map((item, index) => (
        <React.Fragment key={item._id}>

          <FeedCard
            item={item}
            menuPost={menuPost}
            setMenuPost={setMenuPost}
            menuRef={menuRef}
            setActivePost={setActivePost}
            setShowComments={setShowComments}
            onLike={onLike}
            onSave={onSave}
            onHide={onHide}
            onReport={onReport}
            isSaved={savedPosts?.includes(item._id)}
            onConsult={onConsult}
          />

          {/* Product Suggestions */}
          {index % 6 === 2 && (
            <ProductSuggestionRow />
          )}

          {/* Professional Suggestions */}
          {index % 10 === 2 && (
            <ProfessionSuggestionRow />
          )}

          {/* Work Opportunities */}
          {index % 8 === 4 && (
            <WorkSuggestionRow
              onConsult={onConsult}
            />
          )}

        </React.Fragment>
      ))}
    </main>
  );
}

export default FeedList;